export var RouteTypes;
(function (RouteTypes) {
    RouteTypes["default"] = "";
    RouteTypes["embeddedAuthentication"] = "embedded-authentication";
    RouteTypes["signIn"] = "sign-in";
    RouteTypes["signInValidateDeviceCode"] = "sign-in/validate-device-code";
    RouteTypes["signInValidate2fa"] = "sign-in/validate-2fa";
    RouteTypes["changePassword"] = "change-password";
    RouteTypes["changePasswordSetNewPassword"] = "change-password/set-new-password";
    RouteTypes["changePasswordValidateDeviceCode"] = "change-password/validate-device-code";
    RouteTypes["changePasswordValidate2fa"] = "change-password/validate-2fa";
    RouteTypes["changePrimaryEmail"] = "change-primary-email";
    RouteTypes["changePrimaryEmailSetNewEmail"] = "change-primary-email/set-new-email";
    RouteTypes["changePrimaryEmailValidateDeviceCode"] = "change-primary-email/validate-device-code";
    RouteTypes["changePrimaryEmailValidate2fa"] = "change-primary-email/validate-2fa";
    RouteTypes["approval"] = "approval";
    RouteTypes["approvalTransaction"] = "approval/transaction";
    RouteTypes["approvalSignText"] = "approval/sign-text";
    RouteTypes["signUp"] = "sign-up";
    RouteTypes["signUpValidateEmailAddress"] = "sign-up/validate";
    RouteTypes["signUpCreatePassword"] = "sign-up/password";
    RouteTypes["recover"] = "recover";
    RouteTypes["recoverEmailAddressValidate"] = "recover/validate";
    RouteTypes["recoverSetPassword"] = "recover/set-password";
    RouteTypes["recoverValidate2fa"] = "recover/validate-2fa";
    RouteTypes["settings"] = "settings";
    RouteTypes["accountSettings"] = "settings/account-settings";
    RouteTypes["securitySettings"] = "settings/security-settings";
    RouteTypes["securitySettingsTwoFactorAuthentication"] = "settings/security-settings/two-factor-authentication";
    RouteTypes["securitySettingsApprovedDevices"] = "settings/security-settings/approved-devices";
    RouteTypes["securitySettingsApprovedContracts"] = "settings/security-settings/approved-contracts";
    RouteTypes["securitySettingsSecondaryEmails"] = "settings/security-settings/secondary-emails";
    RouteTypes["responsibleGaming"] = "settings/responsible-gaming";
    RouteTypes["responsibleGamingTakeABreak"] = "settings/responsible-gaming/take-a-break";
    RouteTypes["responsibleGamingTakeABreakReview"] = "settings/responsible-gaming/take-a-break/review";
    RouteTypes["responsibleGamingTakeABreakConfirmed"] = "settings/responsible-gaming/take-a-break/confirmed";
    RouteTypes["responsibleGamingSelfExclude"] = "settings/responsible-gaming/self-exclude";
    RouteTypes["responsibleGamingSelfExcludeConfirmed"] = "settings/responsible-gaming/self-exclude/confirmed";
    RouteTypes["responsibleGamingWelcomeBack"] = "settings/responsible-gaming/welcome-back";
    RouteTypes["responsibleGamingWelcomeBackExtendBreak"] = "settings/responsible-gaming/welcome-back/extend-break";
    RouteTypes["responsibleGamingWelcomeBackExtendBreakReview"] = "settings/responsible-gaming/welcome-back/extend-break/review";
    RouteTypes["responsibleGamingWelcomeBackExtendBreakConfirmed"] = "settings/responsible-gaming/welcome-back/extend-break/confirmed";
    RouteTypes["responsibleGamingWelcomeBackSelfExclude"] = "settings/responsible-gaming/welcome-back/self-exclude";
    RouteTypes["responsibleGamingWelcomeBackSelfExcludeConfirmed"] = "settings/responsible-gaming/welcome-back/self-exclude/confirmed";
    RouteTypes["kyc"] = "kyc";
    RouteTypes["kycAlreadyInProgress"] = "kyc/already-in-progress";
    RouteTypes["kycChooseCountry"] = "kyc/choose-country";
    RouteTypes["kycVerify"] = "kyc/verify";
    RouteTypes["kycError"] = "kyc/error";
    RouteTypes["kycYotiDocScanError"] = "kyc/yoti-doc-scan-error";
    RouteTypes["kycYotiCallback"] = "kyc/callback";
    RouteTypes["followerLoading"] = "follower-loading";
    RouteTypes["terms"] = "terms";
    RouteTypes["privacyPolicy"] = "privacy-policy";
    RouteTypes["redirect"] = "redirect";
    RouteTypes["funds"] = "funds";
    RouteTypes["convertFunds"] = "funds/convert";
    RouteTypes["withdrawFunds"] = "funds/withdraw";
    RouteTypes["depositAddress"] = "funds/deposit/address";
    RouteTypes["depositCrypto"] = "funds/deposit/crypto";
    RouteTypes["depositCard"] = "funds/deposit/card";
    RouteTypes["history"] = "history";
    RouteTypes["historyTransfers"] = "history/transfers";
    RouteTypes["historyTransactions"] = "history/transactions";
})(RouteTypes || (RouteTypes = {}));
//# sourceMappingURL=route-types.js.map